import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUDIT_GROUP_ITEM_ADD: "AUDIT_GROUP_ITEM_ADD",
    AUDIT_GROUP_ITEM_CLEAR: "AUDIT_GROUP_ITEM_CLEAR",
    AUDIT_GROUP_ITEM_SET: "AUDIT_GROUP_ITEM_SET",
    AUDIT_GROUP_ITEM_UPDATE: "AUDIT_GROUP_ITEM_UPDATE",

    AUDIT_GROUP_POST_FAILURE: "AUDIT_GROUP_POST_FAILURE",
    AUDIT_GROUP_POST_REQUEST: "AUDIT_GROUP_POST_REQUEST",
    AUDIT_GROUP_POST_SUCCESS: "AUDIT_GROUP_POST_SUCCESS",

    AUDIT_GROUP_PATCH_FAILURE: "AUDIT_GROUP_PATCH_FAILURE",
    AUDIT_GROUP_PATCH_REQUEST: "AUDIT_GROUP_PATCH_REQUEST",
    AUDIT_GROUP_PATCH_SUCCESS: "AUDIT_GROUP_PATCH_SUCCESS",

    AUDIT_GROUPS_CLEAR: "AUDIT_GROUPS_CLEAR",

    AUDIT_GROUPS_GET_FAILURE: "AUDIT_GROUPS_GET_FAILURE",
    AUDIT_GROUPS_GET_REQUEST: "AUDIT_GROUPS_GET_REQUEST",
    AUDIT_GROUPS_GET_SUCCESS: "AUDIT_GROUPS_GET_SUCCESS",

    // Read-only preview from GET .../recommended-group/ -- never itself
    // creates a Group. See audit-groups/saga.js's getRecommendation for why
    // a request can succeed with a null recommendation (branches in this
    // audit disagree on which group they'd get).
    AUDIT_GROUP_RECOMMENDATION_CLEAR: "AUDIT_GROUP_RECOMMENDATION_CLEAR",
    AUDIT_GROUP_RECOMMENDATION_GET_FAILURE:
        "AUDIT_GROUP_RECOMMENDATION_GET_FAILURE",
    AUDIT_GROUP_RECOMMENDATION_GET_REQUEST:
        "AUDIT_GROUP_RECOMMENDATION_GET_REQUEST",
    AUDIT_GROUP_RECOMMENDATION_GET_SUCCESS:
        "AUDIT_GROUP_RECOMMENDATION_GET_SUCCESS"
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.AUDIT_GROUPS_CLEAR
    }),

    getRequest: () => ({
        type: actionTypes.AUDIT_GROUPS_GET_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_GROUPS_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_GROUPS_GET_FAILURE
    }),
    getSuccess: (auditGroups: Array<any>) => ({
        type: actionTypes.AUDIT_GROUPS_GET_SUCCESS,
        payload: { auditGroups }
    }),
    getFailure: (error: Error) => ({
        type: actionTypes.AUDIT_GROUPS_GET_FAILURE,
        error
    }),

    itemAdd: () => ({
        type: actionTypes.AUDIT_GROUP_ITEM_ADD
    }),
    itemClear: () => ({
        type: actionTypes.AUDIT_GROUP_ITEM_CLEAR
    }),
    itemSet: (auditGroup: any) => ({
        type: actionTypes.AUDIT_GROUP_ITEM_SET,
        payload: { auditGroup }
    }),
    itemUpdate: (auditGroup: any) => ({
        type: actionTypes.AUDIT_GROUP_ITEM_UPDATE,
        payload: { auditGroup }
    }),

    postRequest: (auditGroup: Array<any>) => ({
        type: actionTypes.AUDIT_GROUP_POST_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_GROUP_POST_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_GROUP_POST_FAILURE,
        payload: { auditGroup }
    }),
    postSuccess: (auditGroup: Array<any>) => ({
        type: actionTypes.AUDIT_GROUP_POST_SUCCESS,
        payload: { auditGroup }
    }),
    postFailure: (error: Error) => ({
        type: actionTypes.AUDIT_GROUP_POST_FAILURE,
        error
    }),

    patchRequest: (auditGroup: Array<any>) => ({
        type: actionTypes.AUDIT_GROUP_PATCH_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_GROUP_PATCH_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_GROUP_PATCH_FAILURE,
        payload: { auditGroup }
    }),
    patchSuccess: (auditGroup: Array<any>) => ({
        type: actionTypes.AUDIT_GROUP_PATCH_SUCCESS,
        payload: { auditGroup }
    }),
    patchFailure: (error: Error) => ({
        type: actionTypes.AUDIT_GROUP_PATCH_FAILURE,
        error
    }),

    getRecommendationRequest: (branchIds: Array<number>) => ({
        type: actionTypes.AUDIT_GROUP_RECOMMENDATION_GET_REQUEST,
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_GROUP_RECOMMENDATION_GET_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_GROUP_RECOMMENDATION_GET_FAILURE,
        payload: { branchIds }
    }),
    // recommendation is null when there's nothing to recommend -- no
    // branches, or the branches in this audit disagree on which group
    // they'd get (not an error, just nothing to show).
    getRecommendationSuccess: (recommendation: any) => ({
        type: actionTypes.AUDIT_GROUP_RECOMMENDATION_GET_SUCCESS,
        payload: { recommendation }
    }),
    getRecommendationFailure: (error: Error) => ({
        type: actionTypes.AUDIT_GROUP_RECOMMENDATION_GET_FAILURE,
        error
    }),
    recommendationClear: () => ({
        type: actionTypes.AUDIT_GROUP_RECOMMENDATION_CLEAR
    })
};

export default {
    create: actionCreators,
    type: actionTypes
};
